"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const StandardMarkersEnum = Object.freeze({
    CENTER_BOX: "Centerbox",
    CENTER_POINT: "Centerpoint",
    COLD_POINT: "Coldpoint",
    HOT_POINT: "Hotpoint"
});
const _default = StandardMarkersEnum;
